import { useEffect, useState } from "react";
import { Box, TextField } from "@mui/material";
import DialogContainer from "../../../components/dialog-container/dialog-container";

interface RejectOrderDialogProps {
  open: boolean;
  loading: boolean;
  onClose: () => void;
  onSubmit: (reason: string) => void;
}

export default function RejectOrderDialog({
  open,
  loading,
  onClose,
  onSubmit,
}: RejectOrderDialogProps) {
  const [reason, setReason] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    if (open) {
      setReason("");
      setError("");
    }
  }, [open]);

  const handleSubmit = () => {
    if (!reason.trim()) {
      setError("This field can't be empty");
      return;
    }
    onSubmit(reason.trim());
  };

  const handleClose = () => {
    if (!loading) {
      onClose();
    }
  };

  return (
    <DialogContainer
      title="Reject Order"
      showDialog={open}
      closeDialog={handleClose}
      buttonText="Reject"
      onSubmit={handleSubmit}
      saveButtonDisabled={loading}
    >
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <TextField
          value={reason}
          onChange={(event) => {
            setReason(event.target.value);
            if (error) {
              setError("");
            }
          }}
          label="Please explain the reason for rejecting this assignment"
          multiline
          minRows={4}
          fullWidth
          error={Boolean(error)}
          helperText={error}
          InputProps={{
            sx: {
              alignItems: "flex-start",
            },
          }}
        />
      </Box>
    </DialogContainer>
  );
}
